import { UserService } from './../../services/user.service';
import { Component, OnInit } from '@angular/core';
import { ManageBodyshopService } from '../../services/manage-bodyshop.service';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.css']
})
export class ReportsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
